import { SubscriptionPlanUnitType } from "./subscription-plan-unit-type";

export class SubscriptionPlan {
    id:number;
    name:string;
    amountPerUnit:number;
    unitType:SubscriptionPlanUnitType;

    public getUnitTypeNameForQuantity(quantity:number) {
        if (quantity == 1 && this.unitType.endsWith("s")) {
            return this.getSingularUnitType();
        }
        return this.unitType;
    }
    public getSingularUnitType() {
        return this.unitType.substring(0, this.unitType.length - 1);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/subscription-plan.ts